import { __assign, __rest, __spreadArray } from "tslib";
import * as React from 'react';
import { default as MuiBreadcrumbs } from '@material-ui/core/Breadcrumbs';
import { ChevronRightSpecial } from '../../internal/icons/small/ChevronRightSpecial';
import { makeStyles, createStyles } from '../styles';
import { BreadcrumbsContextProvider } from './Breadcrumbs.context';
import { isABreadcrumbItem } from './BreadcrumbsItem';
import { defaultComponents } from './components';
import BreadcrumbsMenu from './components/BreadcrumbsMenu';
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        list: {
            minHeight: '38px',
        },
        listItem: {
            // && adds more specificity so default button/anchor/typography styles are overridden.
            // We cannot directly override these because those components are provided by consumers.
            '&& a': {
                color: theme.palette.text.secondary,
                textDecoration: 'underline',
                fontSize: theme.typography.fontSizeMedium,
                fontFamily: 'inherit',
                '&[role="presentation"]': {
                    color: theme.palette.text.secondary,
                    cursor: 'default',
                    textDecoration: 'none',
                },
                '&:hover': {
                    color: theme.palette.text.primary,
                },
                '&:focus,:active': {
                    color: theme.palette.text.secondary,
                    '&:hover': {
                        color: theme.palette.text.primary,
                    },
                },
                '&:disabled': {
                    outline: 'none',
                },
            },
            '&&:last-child': {
                textDecoration: 'none',
                '& :not(a, button), button:disabled': {
                    color: theme.palette.text.primary,
                    textDecoration: 'inherit',
                },
            },
        },
        separator: {
            color: theme.palette.text.hint,
        },
    });
});
var Breadcrumbs = React.forwardRef(function (props, ref) {
    var ButtonProps = props.ButtonProps, children = props.children, components = props.components, menuButtonLabel = props.menuButtonLabel, href = props.href, _a = props.isCurrentLinkActive, isCurrentLinkActive = _a === void 0 ? true : _a, isCurrentPage = props.isCurrentPage, _b = props.itemsBeforeCollapse, itemsBeforeCollapse = _b === void 0 ? 1 : _b, _c = props.itemsAfterCollapse, itemsAfterCollapse = _c === void 0 ? 1 : _c, label = props.label, menuId = props.menuId, MenuItemProps = props.MenuItemProps, MenuProps = props.MenuProps, navigationLabel = props.navigationLabel, _d = props.separator, separator = _d === void 0 ? React.createElement(ChevronRightSpecial, null) : _d, other = __rest(props, ["ButtonProps", "children", "components", "menuButtonLabel", "href", "isCurrentLinkActive", "isCurrentPage", "itemsBeforeCollapse", "itemsAfterCollapse", "label", "menuId", "MenuItemProps", "MenuProps", "navigationLabel", "separator"]);
    var classes = useStyles();
    var childrenNodes = React.Children.toArray(children).filter(isABreadcrumbItem);
    var renderItemsBeforeAndAfter = function (allItems) {
        var renderItem = function (child, idx) { return (React.createElement("div", { key: idx }, React.cloneElement(child, {
            isCurrentLinkActive: isCurrentLinkActive,
        }))); };
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
            return allItems.map(renderItem);
        }
        var overflowMenuItems = allItems
            .slice(itemsBeforeCollapse, allItems.length - itemsAfterCollapse)
            .map(function (breadcrumbItem) { return ({
            isCurrentPage: breadcrumbItem.props.isCurrentPage,
            label: breadcrumbItem.props.label,
            onClick: breadcrumbItem.props.onClick,
        }); });
        return __spreadArray(__spreadArray(__spreadArray([], allItems.slice(0, itemsBeforeCollapse), true), [
            React.createElement(BreadcrumbsMenu, { menuButtonLabel: menuButtonLabel, breadcrumbsMenuItems: overflowMenuItems, menuId: menuId })
        ], false), allItems.slice(allItems.length - itemsAfterCollapse, allItems.length), true).map(renderItem);
    };
    return (React.createElement(MuiBreadcrumbs, __assign({ "aria-label": navigationLabel, classes: {
            ol: classes.list,
            li: classes.listItem,
            separator: classes.separator,
        }, ref: ref, 
        // This ensures we never use the default expand button from MUI.
        maxItems: Math.max(childrenNodes.length, itemsBeforeCollapse + itemsAfterCollapse), separator: separator }, other), renderItemsBeforeAndAfter(childrenNodes)));
});
export var BreadcrumbsWithContext = React.forwardRef(function (props, ref) {
    var components = props.components, other = __rest(props, ["components"]);
    return (React.createElement(BreadcrumbsContextProvider, __assign({ components: defaultComponents(components) }, other),
        React.createElement(Breadcrumbs, __assign({ ref: ref }, other))));
});
export default BreadcrumbsWithContext;
//# sourceMappingURL=Breadcrumbs.js.map